import { fetchWithAuth } from '../AuthService';
import { DATA_SERVICE_BASE_URL } from '../ApiService';

/**
 * Course-Admin dashboard API — calls endpoints exposed by `CourseAdminController`
 * (gated server-side by @CourseAdminCheck).
 */
export const CourseAdminApi = {
  /** GET /api/courses/{endeavorId}/admin/roster */
  getRoster: async (endeavorId) =>
    fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/courses/${endeavorId}/admin/roster`, { method: 'GET' }),

  /** GET /api/courses/{endeavorId}/admin/progress/summary */
  getProgressSummary: async (endeavorId) =>
    fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/courses/${endeavorId}/admin/progress/summary`, { method: 'GET' }),

  /**
   * GET /api/courses/{endeavorId}/admin/progress/students/{studentUserId}
   * Backend returns 403 for student_shared courses when target != caller.
   */
  getStudentProgress: async (endeavorId, studentUserId) =>
    fetchWithAuth(
      `${DATA_SERVICE_BASE_URL}/api/courses/${endeavorId}/admin/progress/students/${studentUserId}`,
      { method: 'GET' }
    ),

  /** GET /api/courses/{endeavorId}/admin/quiz-attempts (v1 stub returns []) */
  getQuizAttempts: async (endeavorId) =>
    fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/courses/${endeavorId}/admin/quiz-attempts`, { method: 'GET' }),

  /** GET /api/courses/{endeavorId}/admin/flashcard-stats (v1 stub) */
  getFlashcardStats: async (endeavorId) =>
    fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/courses/${endeavorId}/admin/flashcard-stats`, { method: 'GET' }),

  /** GET /api/courses/{endeavorId}/admin/audio-listens (v1 stub) */
  getAudioListens: async (endeavorId) =>
    fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/courses/${endeavorId}/admin/audio-listens`, { method: 'GET' }),

  /** GET /api/courses/admin/mine — all courses the current user can administer */
  getMyAdminCourses: async () =>
    fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/courses/admin/mine`, { method: 'GET' }),
};
